/**
 * Attualmente formattiamo i numeri in base alla lingua italiana.
 */
const numberFormatter = new Intl.NumberFormat('it-IT');

export function formatComputedNumberValue(
  value: string | number | null,
): string {
  return value != null && value !== ''
    ? numberFormatter.format(Number(value))
    : '';
}
